export default __webpack_public_path__ + "static/media/higher_brand_arrow_margin_navy.ed77efaf.svg";